var _rect, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYtIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.998047,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.591 15.203C30.4771 14.7804 30.2546 14.395 29.9454 14.0852C29.6363 13.7753 29.2514 13.5519 28.829 13.437C27.263 13.007 20.998 13 20.998 13C20.998 13 14.734 12.993 13.167 13.404C12.745 13.5242 12.3609 13.7508 12.0516 14.0621C11.7424 14.3735 11.5183 14.7591 11.401 15.182C10.988 16.748 10.984 19.996 10.984 19.996C10.984 19.996 10.98 23.26 11.39 24.81C11.62 25.667 12.295 26.344 13.153 26.575C14.735 27.005 20.983 27.012 20.983 27.012C20.983 27.012 27.248 27.019 28.814 26.609C29.2365 26.4943 29.6218 26.2714 29.9317 25.9622C30.2416 25.653 30.4654 25.2682 30.581 24.846C30.995 23.281 30.998 20.034 30.998 20.034C30.998 20.034 31.018 16.769 30.591 15.203ZM18.994 23.005L18.999 17.005L24.206 20.01L18.994 23.005Z",
    fill: "url(#paint0_linear_5611_41976)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5611_41976",
    x1: 10.984,
    y1: 20.006,
    x2: 30.9982,
    y2: 20.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3912D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A312D6"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYtIcon);
export default __webpack_public_path__ + "static/media/yt-icon.3d558da8adac98c6f732ebb40cc3ba16.svg";
export { ForwardRef as ReactComponent };